module.exports = __webpack_public_path__ + "img/ertiga-xl7-2022.48fde8b2.svg";